import { SERVER } from "./defaults";
import { checkGeometry, emptyIfNull3, emptyIfNull4 } from "./helpers";

const handleModal = (e, map, toggleModal) => {
  const modalDetails = document.querySelector("#gna-modal-details");
  const modalHeaderTitle = document.querySelector("#gna-modal-header-title");
  const modalContent = document.querySelector("#gna-modal-content");

  const feature = map.forEachFeatureAtPixel(e.pixel, (feature) => {
    return feature;
  });

  if (!feature) {
    return;
  }

  toggleModal();

  const nome = feature.get("nome");
  const descrizione = feature.get("descrizione");
  const comune = feature.get("comune");
  const provincia = feature.get("provincia");
  const regione = feature.get("regione");
  const sigla = feature.get("sigla");
  const linkFoto = feature.get("link_foto");

  const bibliografia = feature.get("Bibliografia");
  const IGMfoglio = feature.get("IGMfoglio");
  const quadrante = feature.get("Quadrante");
  const tavoletta = feature.get("Tavoletta");
  const titolo = feature.get("Titolo");
  const oggetto = feature.get("Oggetto");
  const CODICE_SCH = feature.get("CODICE_SCH");
  const compilatore = feature.get("Compilatore");
  const descrizioneGreen = feature.get("Descrizione");
  const localita = feature.get("Località");

  const url = feature.get("url");
  const gid = feature.get("gid");
  const accc = feature.get("ACCC");
  const ogd = feature.get("OGD");
  const ogt = feature.get("OGT");
  const ogn = feature.get("OGN");
  const loc1 = feature.get("LCC");
  const loc2 = feature.get("LCP");
  const loc3 = feature.get("LCR");
  const location = `${loc1} (${loc2}) - ${loc3}`;
  const lci = feature.get("LCI");
  const pvl = feature.get("PVL");
  const des = feature.get("DES");
  const dtr = feature.get("DTR");
  const cdgg = feature.get("CDGG");
  const gen = feature.get("GEN");
  const cma = feature.get("CMA");
  const cmc = feature.get("CMC");
  const cmr = feature.get("CMR");
  const adp = feature.get("ADP");
  const ssk = feature.get("SSK");
  const data_ins = feature.get("data_ins");
  const data_upd = feature.get("data_upd");
  const ogb = feature.get("OGB");
  const acba = feature.get("ACBA");
  const bibm = feature.get("BIBM");
  const gpt = feature.get("GPT");
  const gpm = feature.get("GPM");
  const gpbb = feature.get("GPBB");
  const fur = feature.get("FUR");
  const ogm = feature.get("OGM");
  const mtam = feature.get("MTAM");
  const mtax = feature.get("MTAX");
  const ctg = feature.get("CTG");
  const cae = feature.get("CAE");
  const cas = feature.get("CAS");
  const caa = feature.get("CAA");
  const cav = feature.get("CAV");
  const geometryName = checkGeometry(url);
  const icon =
    SERVER +
    "/images/MOSI_multipoint" +
    feature.get("id_macrocategoria") +
    ".svg";
  const macrocategoria = feature.get("macrocategoria");

  let contentHtml = ``;

  if (
    nome != null &&
    sigla != null &&
    comune != null &&
    regione != null &&
    descrizione != null
  ) {
    modalHeaderTitle.innerHTML = `Tess`;
    contentHtml += `<div class="gna-modal-content-text">
        <p>Nome: <span>${nome}</span></p>
        <p>Descrizione: <span>${descrizione}</span></p>`;
    if (linkFoto != null) {
      contentHtml += `<img src="${linkFoto}"/>`;
    }
    contentHtml += `<p>Localizzazione: <span>${comune}</span> <span>(${sigla})</span> - <span>${regione}</span></p>
        </div>`;
  } else if (CODICE_SCH != null && IGMfoglio != null) {
    modalHeaderTitle.innerHTML = `Censimento`;
    contentHtml += `<div class="gna-modal-content-text">
        <h3>Definizione</h3>
        <p>Oggetto: <span>${oggetto}</span></p>
        <p>Descrizione: <span>${descrizioneGreen}}</span></p>
        <h3>Definizione</h3>
        <p>Località: <span>${localita}</span></p>
        <h3>Cartografia IGM</h3>
        <p>Foglio: <span>${IGMfoglio}</span></p>
        <p>Quadrante: <span>${quadrante}</span></p>
        <p>Tavoletta: <span>${tavoletta}</span></p>
        <p>Titolo: <span>${titolo}</span></p>
        <h3>Bibliografia</h3>
        <p>Bibliografia: <span>${bibliografia}</span></p>
        <h3>Scheda</h3>
        <p>Codice: <span>${CODICE_SCH}</span></p>
        <p>Compilatore: <span>${compilatore}</span></p>
        </div>`;
  } else if (
    geometryName != "progetti" &&
    nome != null &&
    descrizione != null
  ) {
    modalHeaderTitle.innerHTML = `Concessioni`;
    contentHtml += `<div class="gna-modal-content-text">
        <p>Nome: <span>${nome}</span></p>
        <p>Descrizione: <span>${descrizione}</span></p>
        </div>`;
  } else if (
    nome != null &&
    provincia != null &&
    comune != null &&
    regione != null
  ) {
    modalHeaderTitle.innerHTML = `Catalogo ICCD`;
    contentHtml += `<div class="gna-modal-content-text">
        <p>Nome: <span>${nome}</span></p>
        <p>Localizzazione: <span>${comune}</span> <span>(${provincia})</span> - <span>${regione}</span></p>
        </div>`;
  } else if (geometryName != "progetti") {
    modalHeaderTitle.innerHTML = `Siti (${geometryName})`;

    contentHtml += `
        ${emptyIfNull3(icon, macrocategoria)}
        <div class="gna-modal-content-text">
            <h3>IDENTIFICAZIONE</h3>
            ${emptyIfNull4("GID", gid)}
            ${emptyIfNull4("Progetto", ctg)}
            ${emptyIfNull4("Codice identificativo", accc)}
            ${emptyIfNull4("Definizione", ogd)}
            ${emptyIfNull4("Tipologia", ogt)}
            ${emptyIfNull4("Denominazione", ogn)}
            ${emptyIfNull4("Stato di conservazione", ogb)}
            <h3>LOCALIZZAZIONE E QUOTE</h3>
            ${emptyIfNull4("Localizzazione", location)}
            ${emptyIfNull4("Indirizzo", lci)}
            ${emptyIfNull4("Toponimo/ località", pvl)}
        `;

    if (gen || gpt || gpm || gpbb) {
      contentHtml += `
            <h3 class="gna-modal-little-header">Georeferenziazione <i class="fa-solid fa-chevron-down" style="color: #ff0000;"></i></h3>
            <div class="gna-modal-panel">
                ${emptyIfNull4("Note alla georeferenziazione", gen)}
                ${emptyIfNull4("Tecnica di georeferenziazione", gpt)}
                ${emptyIfNull4("Grado di precisione del posizionamento", gpm)}
                ${emptyIfNull4("Base cartografica", gpbb)}
            </div>`;
    }

    if (mtam || mtax) {
      contentHtml += `
            <h3 class="gna-modal-little-header">Quote <i class="fa-solid fa-chevron-down" style="color: #ff0000;"></i></h3>
            <div class="gna-modal-panel">
                ${emptyIfNull4("Quota minima", mtam)}
                ${emptyIfNull4("Quota massima", mtax)}
            </div>`;
    }

    contentHtml += `
            ${emptyIfNull4("Accessibilità", acba)}
            <h3>DATA ANALITICI</h3>
            ${emptyIfNull4("Descrizione", des)}
            ${emptyIfNull4("Modalità di individuazione", ogm)}
            ${emptyIfNull4("Cronologia", dtr)}
        `;

    if (cae || cas || caa || cav) {
      contentHtml += `
            <h3 class="gna-modal-little-header">Caratteri ambientali <i class="fa-solid fa-chevron-down" style="color: #ff0000;"></i></h3>
            <div class="gna-modal-panel">
                ${emptyIfNull4("Geomorfoogia", cae)}
                ${emptyIfNull4("Caratteri ambientali storici", cas)}
                ${emptyIfNull4("Caratteri ambientali attuali", caa)}
                ${emptyIfNull4("Sintesi storico archeologica", cav)}
            </div>`;
    }

    contentHtml += `
            <h3>CONDIZIONE GIURIDICA E PROVVEDIMENTI AMMINISTRATIVI</h3>
            ${emptyIfNull4("Condizione giuridica", cdgg)}
            <h3>BIBLIOGRAFIA E CERTIFICAZIONE DEI DATI</h3>
            ${emptyIfNull4("Bibliografia", bibm)}
        `;

    if (cma || fur || cmc || cmr || adp || ssk || data_ins || data_upd) {
      contentHtml += `
            <h3 class="gna-modal-little-header">Compilazione <i class="fa-solid fa-chevron-down" style="color: #ff0000;"></i></h3>
            <div class="gna-modal-panel">
                ${emptyIfNull4("Anno di redazione", cma)}
                ${emptyIfNull4("Funzionario responsabile", fur)}
                ${emptyIfNull4("Redazione del modulo", cmc)}
                ${emptyIfNull4("Responsabile dei contenuti", cmr)}
                ${emptyIfNull4("Profilo di accesso", adp)}
                ${emptyIfNull4("Stato della scheda", ssk)}
                ${emptyIfNull4("Primo inserimento dei dati", data_ins)}
                ${emptyIfNull4("Ultimo aggiornamento dei dati", data_upd)}
            </div>`;
    }

    contentHtml += `</div>`;
  } else {
    modalHeaderTitle.innerHTML = `${geometryName}`;

    contentHtml += `
        ${emptyIfNull3(icon, macrocategoria)}
        <div class="gna-modal-content-text">
            <h3>IDENTIFICAZIONE</h3>
            ${emptyIfNull4("GID", gid)}
            ${emptyIfNull4("Progetto", ctg)}
            ${emptyIfNull4("Codice identificativo", accc)}
            ${emptyIfNull4("Definizione", ogd)}
            ${emptyIfNull4("Tipo opera/ Attività", ogt)}
            ${emptyIfNull4("Denominazione", ogn)}
            ${emptyIfNull4("Stato di conservazione", ogb)}
            <h3>LOCALIZZAZIONE E QUOTE</h3>
            ${emptyIfNull4("Localizzazione", location)}
            ${emptyIfNull4("Indirizzo", lci)}
            ${emptyIfNull4("Toponimo/ località", pvl)}
        `;

    if (gen || gpt || gpm || gpbb) {
      contentHtml += `
            <h3 class="gna-modal-little-header">Georeferenziazione <i class="fa-solid fa-chevron-down" style="color: #ff0000;"></i></h3>
            <div class="gna-modal-panel">
                ${emptyIfNull4("Tecnica di georeferenziazione", gpt)}
                ${emptyIfNull4("Base cartografica", gpbb)}
                ${emptyIfNull4("Grado di precisione del posizionamento", gpm)}
                ${emptyIfNull4("Note alla georeferenziazione", gen)}
            </div>`;
    }

    if (mtam || mtax) {
      contentHtml += `
            <h3 class="gna-modal-little-header">Quote <i class="fa-solid fa-chevron-down" style="color: #ff0000;"></i></h3>
            <div class="gna-modal-panel">
                ${emptyIfNull4("Quota minima", mtam)}
                ${emptyIfNull4("Quota massima", mtax)}
            </div>`;
    }

    contentHtml += `
            ${emptyIfNull4("Accessibilità", acba)}
            <h3>DATA ANALITICI</h3>
            ${emptyIfNull4("Descrizione", des)}
            ${emptyIfNull4("Modalità di individuazione", ogm)}
            ${emptyIfNull4("Cronologia", dtr)}
        `;

    if (cae || cas || caa || cav) {
      contentHtml += `
            <h3 class="gna-modal-little-header">Caratteri ambientali <i class="fa-solid fa-chevron-down" style="color: #ff0000;"></i></h3>
            <div class="gna-modal-panel">
                ${emptyIfNull4("Geomorfoogia", cae)}
                ${emptyIfNull4("Caratteri ambientali storici", cas)}
                ${emptyIfNull4("Caratteri ambientali attuali", caa)}
                ${emptyIfNull4("Sintesi storico archeologica", cav)}
            </div>`;
    }

    contentHtml += `
            <h3>CONDIZIONE GIURIDICA E PROVVEDIMENTI AMMINISTRATIVI</h3>
            ${emptyIfNull4("Condizione giuridica", cdgg)}
            <h3>BIBLIOGRAFIA E CERTIFICAZIONE DEI DATI</h3>
            ${emptyIfNull4("Bibliografia", bibm)}
        `;

    if (cma || fur || cmc || cmr || adp || ssk || data_ins || data_upd) {
      contentHtml += `
            <h3 class="gna-modal-little-header">Compilazione <i class="fa-solid fa-chevron-down" style="color: #ff0000;"></i></h3>
            <div class="gna-modal-panel">
                ${emptyIfNull4("Anno di redazione", cma)}
                ${emptyIfNull4("Funzionario responsabile", fur)}
                ${emptyIfNull4("Redazione del modulo", cmc)}
                ${emptyIfNull4("Responsabile dei contenuti", cmr)}
                ${emptyIfNull4("Profilo di accesso", adp)}
                ${emptyIfNull4("Stato della scheda", ssk)}
                ${emptyIfNull4("Primo inserimento dei dati", data_ins)}
                ${emptyIfNull4("Ultimo aggiornamento dei dati", data_upd)}
            </div>`;
    }

    contentHtml += `</div>`;
  }

  modalContent.innerHTML = contentHtml;

  const headers = document.querySelectorAll(".gna-modal-little-header");
  headers.forEach((header) => {
    const panel = header.nextElementSibling;
    const i = header.querySelector("i");
    header.addEventListener("click", () => {
      i.classList.toggle("open");
      panel.classList.toggle("active");
    });
  });
};

export { handleModal };
